import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { ApiKeyAPI } from '@business/api/apikey';
import { ApiKeyId, ApiKeyResponse } from '@business/entities/apikey';
export class ApiKeyBloc extends BaseBloc {
  private readonly apiKeyRepo = new Repository<ApiKeyResponse>({
    getItemId: brand => brand.id,
  });

  readonly apiKeys$ = this.apiKeyRepo.items$;

  onReset() {
    this.apiKeyRepo.reset();
  }

  fetchApiKeys = () => {
    return ApiKeyAPI.fetchApiKeys().pipe(this.apiKeyRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_apikey_error') }));
  };

  createApiKey = () => {
    return ApiKeyAPI.createApiKey().pipe(
      this.apiKeyRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_apikey'),
      }),
    );
  };

  toggleApiKey = (id: ApiKeyId) => {
    return ApiKeyAPI.toggle(id).pipe(
      this.apiKeyRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_apikey'),
      }),
    );
  };

  deleteApiKey = (id: ApiKeyId) => {
    return showDeleteConfirmation('Delete ApiKey', 'Do you really want to remove this API key?').pipe(
      switchMap(() => ApiKeyAPI.deleteApiKey(id)),
      this.apiKeyRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_apikey'),
      }),
    );
  };
}
